// marketplace/FilterDropdown.jsx
// Filter panel dropdown.
// Categories are shown as scrollable pill buttons at the top.
// Also contains price range and entrega hoy toggle.
// CategoriesRow has been removed — this is the single place for category filtering.

import React from "react";
import { brand } from "../shared/brand";

export function FilterDropdown({
  categories,
  query,
  activeFilters,
  setCategory,
  setMinPrice,
  setMaxPrice,
  toggleEntregaHoy,
  clearFilters,
}) {
  return (
    <div className="absolute right-0 top-full mt-2 w-80 rounded-2xl border border-slate-200 bg-white shadow-xl z-40 p-4">

      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <span className="text-sm font-semibold text-slate-800">Filtros</span>
        {activeFilters > 0 && (
          <button
            onClick={clearFilters}
            className="text-xs font-semibold transition-colors"
            style={{ color: brand.primary }}
          >
            Limpiar todo
          </button>
        )}
      </div>

      {/* Price range */}
      <div className="mb-4">
        <label className="block text-xs font-semibold text-slate-500 mb-2 uppercase tracking-wide">
          Precio (S/)
        </label>
        <div className="flex items-center gap-2">
          <input
            type="number"
            placeholder="Mín"
            value={query.minPrice}
            onChange={e => setMinPrice(e.target.value)}
            className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm outline-none focus:border-slate-400"
          />
          <span className="text-slate-400 shrink-0">–</span>
          <input
            type="number"
            placeholder="Máx"
            value={query.maxPrice}
            onChange={e => setMaxPrice(e.target.value)}
            className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm outline-none focus:border-slate-400"
          />
        </div>
      </div>

      <div className="border-t border-slate-100 my-3" />

      {/* Entrega hoy toggle */}
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-semibold text-slate-700">Entrega hoy</p>
          <p className="text-xs text-slate-400">Solo productos con stock en Fast Max</p>
        </div>
        <button
          onClick={toggleEntregaHoy}
          className="relative w-9 h-5 rounded-full transition-colors shrink-0 ml-3"
          style={{ background: query.entregaHoyOnly ? brand.accentGreen : "#cbd5e1" }}
          aria-label="Filtrar entrega hoy"
        >
          <span
            className="absolute top-0.5 left-0.5 size-4 rounded-full bg-white shadow transition-transform duration-200"
            style={{ transform: query.entregaHoyOnly ? "translateX(16px)" : "translateX(0)" }}
          />
        </button>
      </div>

      {/* Category pills — at the bottom */}
      {categories.length > 0 && (
        <>
          <div className="border-t border-slate-100 my-3" />
          <div>
            <label className="block text-xs font-semibold text-slate-500 mb-2 uppercase tracking-wide">
              Categoría
            </label>
            <div
              className="flex flex-wrap gap-1.5 max-h-28 overflow-y-auto pr-1"
              style={{ scrollbarWidth: "thin" }}
            >
              <button
                onClick={() => setCategory("")}
                className="rounded-full px-3 py-1 text-xs font-semibold border transition-all shrink-0"
                style={
                  query.selectedCategory === ""
                    ? { background: brand.primary, color: "white", borderColor: brand.primary }
                    : { background: "white", color: "#374151", borderColor: "#e2e8f0" }
                }
              >
                Todas
              </button>

              {categories.map(cat => {
                const isActive = query.selectedCategory === cat.slug;
                return (
                  <button
                    key={cat.id}
                    onClick={() => setCategory(cat.slug)}
                    className="rounded-full px-3 py-1 text-xs font-semibold border transition-all shrink-0"
                    style={
                      isActive
                        ? { background: brand.primary, color: "white", borderColor: brand.primary }
                        : { background: "white", color: "#374151", borderColor: "#e2e8f0" }
                    }
                  >
                    {cat.name}
                  </button>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
}